import { createFileRoute, Navigate, useNavigate } from "@tanstack/react-router";
import { useAuth } from "../../contexts/AuthContext";

export const Route = createFileRoute("/dashboard/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { user, userProfile, loading, profileLoading, error } = useAuth();
  const navigate = useNavigate();

  // useEffect(() => {
  //   // Redirect to login if not authenticated
  //   if (!loading && !user) {
  //     navigate({ to: "/login" });
  //     return;
  //   }

  //   // Navigate based on user profile type once both auth and profile are loaded
  //   if (!loading && !profileLoading && user && userProfile) {
  //     switch (userProfile.type) {
  //       case "admin":
  //         navigate({ to: "/dashboard/admin" });
  //         break;
  //       case "manager":
  //         navigate({ to: "/dashboard/admin" });
  //         break;
  //       case "customer":
  //         navigate({ to: "/dashboard/customer" });
  //         break;
  //       case "worker":
  //         navigate({ to: "/dashboard/worker" });
  //         break;
  //       default:
  //         console.error("Unknown user type:", userProfile.type);
  //     }
  //   }

  //   // Handle case where user is authenticated but has no profile
  //   if (!loading && !profileLoading && user && !userProfile) {
  //     console.error("User authenticated but no profile found");
  //   }
  // }, [user, userProfile, loading, profileLoading, navigate]);

  // Show loading while authentication or profile is loading
  if (loading || profileLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900"></div>
          <p className="text-gray-600">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  // Show error if there's an authentication error
  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <p className="mb-4 text-red-600">Error: {error}</p>
          <button
            onClick={() => navigate({ to: "/login" })}
            className="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  // Show error if user is authenticated but no profile exists
  if (user && !userProfile) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <p className="mb-4 text-red-600">Profile not found. Please contact support.</p>
          <button
            onClick={() => navigate({ to: "/login" })}
            className="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  console.log(
    "User authenticated:",
    user,
    "Profile:",
    userProfile,
    "Loading:",
    loading,
    "ProfileLoading:",
    profileLoading,
  );

  // Check if user's access has been revoked
  if (!loading && !profileLoading && user && userProfile && userProfile.accessRevoked) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <p className="mb-4 text-red-600">
            Your access has been revoked. Please contact support for assistance.
          </p>
          <button
            onClick={() => navigate({ to: "/login" })}
            className="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
          >
            Go to Login
          </button>
        </div>
      </div>
    );
  }

  if (!loading && !profileLoading && user && userProfile) {
    if (userProfile.type === "manager") {
      return <Navigate to="/dashboard/admin" />;
    } else if (userProfile.type === "admin") {
      return <Navigate to="/dashboard/admin" />;
    } else if (userProfile.type === "support") {
      return <Navigate to="/dashboard/admin" />;
    } else if (userProfile.type === "customer") {
      return <Navigate to="/dashboard/customer" />;
    } else if (userProfile.type === "worker") {
      return <Navigate to="/dashboard/worker" />;
    } else if (userProfile.type === "agency") {
      return <Navigate to="/dashboard/agency" />;
    }
  }

  // Fallback - should not reach here normally
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <p className="text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
}
